import { ClickEvent } from "@mcleod/components";
import { Navigation } from "@mcleod/core";
import { PortalCustomerSettings } from "@mcleod/portal-customer";
import { AutogenLayoutOrderConfirmationHeader } from "./autogen/AutogenLayoutOrderConfirmationHeader";

export class OrderConfirmationHeader extends AutogenLayoutOrderConfirmationHeader {

    override onLoad() {
        this.labelOrderSubmitMsg.text = PortalCustomerSettings.get().order_submit_ok ?? "";
    }

    buttonListViewOnClick(event: ClickEvent) {
        Navigation.navigateTo("/");
    }


    displayHoldPanel(holdWarning: any) {
        const warningText = holdWarning?.text;
        if (warningText) {
            this.panelHold.visible = true;
            this.labelHold.text = warningText;
            this.labelHoldEmail.visible = holdWarning?.email;
            this.labelHoldEmail.text = holdWarning?.email;
            if (holdWarning?.email && holdWarning?.subject)
                this.labelHoldEmail.link = `mailto:${holdWarning?.email}?subject=${holdWarning?.subject}`;
        }
    }
}
